import axios from "axios";
import { CAT, PATH } from "../Utils/Constantes";

// Create instance called instance
const instance = axios.create({
  baseURL: PATH,
});

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  getParentescos: () =>
    instance({
      method: "GET",
      url: CAT+'Parentesco',
    }),
  genero: () =>
    instance({
      method: "GET",
      url: CAT+'Genero',
    }),
  padecimiento: () =>
    instance({
      method: "GET",
      url: CAT+'padecimiento',
    }),
  medioContacto: () =>
    instance({
      method: "GET",
      url: CAT+'MedioContacto',
    }),
  //Lead
  getContratante: (folio) =>
    instance({
      method: "GET",
      url: 'Contratante/'+folio,
    }),
  getAsegurado: (idContratante) =>
    instance({
      method: "GET",
      url: 'asegurado/'+idContratante,
    }),
  padecimientos: (idContratante, idAsegurado) =>
    instance({
      method: "GET",
      url: 'Padecimiento/'+idContratante+'/'+idAsegurado,
    }),
    //cp
  consultaCP: (cp) =>
    instance({
      method: "GET",
      url: 'CP/'+cp,
    }),
  validaCP: (cp) =>
    instance({
      method: "GET",
      url: 'CP/Existe/'+cp,
    }),
  //Lead put
  guardaContratante: (contratante) =>
    instance({
      method: "PUT",
      url: 'Contratante/Save/',
      data: contratante,
    }),
  actualizaContratante: (IdContratante, contratante) =>
    instance({
      method: "PUT",
      url: 'Contratante/Save/'+IdContratante,
      data: contratante,
    }),
  guardaAsegurado: (IdContratante, asegurado) =>
    instance({
      method: "PUT",
      url: 'Asegurado/Save/'+IdContratante,
      data: asegurado,
    }),
  actualizaAsegurado: (IdContratante, asegurado) =>
    instance({
      method: "PUT",
      url: 'Asegurado/Save/'+IdContratante+'/'+asegurado.idAsegurado,
      data: asegurado,
    }),
  }